import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { isEmpty, toUpper } from 'lodash'

import { BasicModal } from '@/components/layout/modals/BasicModal'
import { OrgHierarchySelector } from '@/views/OrgHierarchy/OrgHierarchySelector'
import { ActionsDropdown } from '@/components/dropdowns/ActionsDropdown'
import { NotificationBell } from '@/components/notifications/NotificationBell'
import { useDocsHub } from '@/utils/hooks/useDocsHub'

import { AgentAssistLauncher } from './AgentAssistLauncher'
import { DarkModeToggle } from './DarkModeToggle'

export const SidebarFooter = ({
  currentUser,
  userOrgHierarchy,
  handleLogout,
  sidebarCollapsed,
  isBaltoAdmin,
  showAgentAssist,
  showConnectedApps,
}) => {
  const history = useHistory()
  const [showHierarchyModal, setShowHierarchyModal] = useState(false)
  const isHierarchyManager = currentUser.hierarchy_manager
  const userFirstName = currentUser.first_name
  const { openDocsHub } = useDocsHub()

  const handleSwitchOrganization = () => {
    setShowHierarchyModal(true)
  }

  const actions = [
    { label: 'Docs Hub', onClick: openDocsHub, testId: 'docs-hub-button' },
    {
      label: 'Sign Out',
      onClick: handleLogout,
      testId: 'sign-out-button',
      isDanger: true,
      hasSeparator: true,
    },
  ]

  if (showConnectedApps) {
    actions.unshift({
      label: 'Connected Apps',
      onClick: () => history.push('/connected-apps'),
      testId: 'connected-apps-button',
    })
  }

  if (!isEmpty(userOrgHierarchy) && isHierarchyManager) {
    actions.unshift({
      label: 'Switch Organization',
      onClick: handleSwitchOrganization,
      testId: 'org-hierarchy-button',
    })
  }

  if (isBaltoAdmin) {
    actions.unshift({
      label: 'Organization Management',
      onClick: () => history.push('/organizations'),
    })
  }

  return (
    <>
      {/* Footer: the user's avatar + first name on the left, then the action
          icons — notification bell, Agent Assist launcher (RTC-access only), and
          the 3-dot menu (settings/sign-out/etc.). The bell's sidebar-anchored
          panel re-anchors to the rail when collapsed; the identity hides when
          collapsed. */}
      <footer className="balto-sidebar__footer">
        {!sidebarCollapsed && (
          <div className="flex-align-center small-gap balto-sidebar__footer-user">
            <span className="balto-sidebar__footer-avatar" aria-hidden="true">
              {toUpper(userFirstName).charAt(0)}
            </span>
            <div className="text-overflow">{userFirstName}</div>
          </div>
        )}
        <div className="balto-sidebar__footer-actions">
          <NotificationBell collapsed={sidebarCollapsed} />
          {showAgentAssist && <AgentAssistLauncher collapsed={sidebarCollapsed} />}
          <DarkModeToggle collapsed={sidebarCollapsed} />
          <ActionsDropdown
            actions={actions}
            buttonProps={{
              'aria-label': 'More options',
              tooltip: 'More options',
              tooltipProps: { placement: sidebarCollapsed ? 'right' : 'top' },
            }}
          />
        </div>
      </footer>
      <BasicModal
        title="Switch Organization"
        onClose={() => setShowHierarchyModal(false)}
        show={showHierarchyModal}
        size="tiny"
      >
        <OrgHierarchySelector
          currentUserOrgId={currentUser.organizationid}
          userOrgHierarchy={userOrgHierarchy}
        />
      </BasicModal>
    </>
  )
}
